import { create } from 'zustand';
import { platformApi, setSessionExpiredHandler } from './platformApi.js';
import { toast } from '../../shared/useToast.js';

// جلسة مدير النظام — مستقلّة تماماً عن جلسة مستخدمي الشركات (shared/useAuth.js).
export const usePlatformAuth = create((set, get) => ({
  user: null,
  ready: false,
  loading: false,

  /** فحص الجلسة عند تحميل البوابة — 401 يعني «غير مسجّل» لا أكثر. */
  bootstrap: async () => {
    if (get().loading) return;
    set({ loading: true });
    try {
      const { data } = await platformApi.get('/platform/me');
      set({ user: data?.user || null, ready: true, loading: false });
    } catch {
      set({ user: null, ready: true, loading: false });
    }
  },

  login: async ({ username, password }) => {
    const { data } = await platformApi.post('/platform/login', { username, password });
    const user = data?.user || null;
    set({ user, ready: true });
    return user;
  },

  logout: async () => {
    try {
      await platformApi.post('/platform/logout');
    } catch { /* نُخرج المستخدم محلياً على أي حال */ }
    set({ user: null, ready: true });
  },

  /** الخادم يُلغي كوكي الجلسة بعد التغيير → نُعيد المدير إلى شاشة الدخول. */
  changePassword: async ({ currentPassword, newPassword }) => {
    await platformApi.post('/platform/change-password', { currentPassword, newPassword });
    set({ user: null, ready: true });
  },

  clear: () => set({ user: null, ready: true })
}));

// انتهاء الجلسة أثناء الاستخدام: نُفرّغ الحالة فقط، والحارس يُظهر شاشة دخول البوابة
// (بدون تحويل المتصفّح إلى /login الخاصة بالشركات).
setSessionExpiredHandler(() => {
  if (usePlatformAuth.getState().user) {
    toast.error('انتهت الجلسة — يرجى تسجيل الدخول من جديد');
  }
  usePlatformAuth.getState().clear();
});
